if (typeof window === 'undefined') {
    throw new Error('This module is not meant to run outside the browser.')
}

const Marionette = require('lib/marionette')

const MarionetteBridge = Marionette.MnObject.extend({

    initialize(options) {

        this.initializeGlobals()
        this.initializeViewer()
        this.initializeBrowser()
        this.initializeViewport()
        this.initializeConveniences()

        if (__DEBUG__) {
            this.initializeDebugHelpers()
        }
    },

    initializeGlobals() {
        const _ = require('lib/underscore')
        const g = require('globals')
        _.extend(g, this.options.globals)

        // console convenience
        this.globals = g
    },

    initializeViewer() {
        // initialize viewer
        const viewer = require('module/viewer/viewer')
        viewer.initializeModel(this.options.viewer)

        // console convenience
        this.viewer = viewer
    },

    initializeBrowser() {
        this.browser = require('module/browser/browser')
    },

    initializeViewport() {
        this.viewport = require('module/viewport/viewport')
    },

    initializeDebugHelpers() {
        if (__DEBUG__) {
            require.ensure([], () => {
                const DebugHelpers = require('lib/debug/debug_helpers')
                DebugHelpers.initialize()
            }, 'debug_helper')
        }
    },

    initializeConveniences() {
        // expose radio
        this.radio = require('lib/radio')

        // expose config
        this.config = require('lib/config')

        // expose AboutMe on window
        window.AboutMe = this
    },

})

module.exports = MarionetteBridge
